import { Text } from '@byecode/ui'
import { FILE_MODE } from '@lighthouse/core'
import { FileFieldBlockThumbImageMap } from '@lighthouse/shared'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import type { FieldInputFormSlice } from '../formSlice'
import { StyleSwitcherGrid } from './CalendarMode'

const SCxContainer = styled.div`
    padding: 12px 16px;
`

const OPTIONS = [
    {
        label: '列表',
        value: FILE_MODE.list,
        image: FileFieldBlockThumbImageMap[FILE_MODE.list],
        color: 'var(--color-main)',
        background: 'var(--color-purple-100)'
    },
    {
        label: '缩略图',
        value: FILE_MODE.thumbnail,
        image: FileFieldBlockThumbImageMap[FILE_MODE.thumbnail],
        color: 'var(--color-main)',
        background: 'var(--color-purple-100)'
    },
    {
        label: '宫格',
        value: FILE_MODE.grid,
        image: FileFieldBlockThumbImageMap[FILE_MODE.grid],
        color: 'var(--color-main)',
        background: 'var(--color-purple-100)'
    }
]

interface FileModeProps {}

export const FileMode: React.FC<FileModeProps> = () => {
    const { control } = useFormContext<FieldInputFormSlice>()
    return (
        <SCxContainer>
            <Text>显示方式</Text>
            <Controller
                control={control}
                name="file.mode"
                // 兼容之前的月日历
                defaultValue="list"
                render={({ field }) => (
                    <StyleSwitcherGrid
                        options={OPTIONS}
                        value={field.value}
                        onChange={val => {
                            field.onChange(val)
                        }}
                    />
                )}
            />
        </SCxContainer>
    )
}
